// extracted by mini-css-extract-plugin
module.exports = {"header":"_2wy2VKK4","content":"_1KY5xmwG","disclaimer":"_2eLOHyhx","secondaryDisclaimer":"_1cv0pqs4","footer":"_1qRlzpvq","modal":"_3Bq9AO0y"};